import { PageShell } from "@/components/common/PageShell";
import { SupportLine } from "@/components/common/SupportLink";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

/**
 * A full page with one message: errors, a link that cannot work, a page that
 * does not exist. A centred card after Cal.com's confirmation page, always
 * ending with the support line, and `actions` for anything the person can do
 * about it (retry, rejoin).
 */
export const StatusScreen = ({
  icon: Icon,
  tone = "neutral",
  title,
  description,
  actions,
  testId,
}) => (
  <PageShell>
    <Card className="w-full max-w-md gap-0 py-0" data-testid={testId}>
      <div className="flex flex-col items-center gap-4 px-6 py-8 text-center sm:px-8">
        {Icon ? (
          <div
            className={cn(
              "flex size-11 items-center justify-center rounded-full",
              tone === "error"
                ? "bg-destructive/10 text-destructive"
                : "bg-muted text-foreground"
            )}
          >
            <Icon className="size-5" />
          </div>
        ) : null}
        <div className="flex flex-col gap-1.5">
          <h1 className="text-lg font-semibold tracking-tight text-balance">
            {title}
          </h1>
          {description ? (
            <p className="text-sm text-balance text-muted-foreground">
              {description}
            </p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex flex-wrap justify-center gap-2">{actions}</div>
        ) : null}
      </div>
      <div className="border-t px-6 py-4 text-center">
        <SupportLine />
      </div>
    </Card>
  </PageShell>
);
